// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rYyI","index":"styles_index__2e0EV"};